import React from 'react';
import { CompanyList } from '../components/companies/CompanyList';

export function CompaniesPage() {
  return (
    <>
      <div className="page-header">
        <div>
          <div className="page-header-title">Investoren</div>
          <div className="page-header-sub">Investoren &amp; Ankaufsprofile</div>
        </div>
      </div>
      <div className="content">
        <CompanyList />
      </div>
    </>
  );
}
